import type { AiOperationSimulation, AiOperationalRiskLevel } from '../../types/aiOperational'
import { ExecutionRiskBadge } from './ExecutionRiskBadge'

export const ExecutionRiskPanel = ({
  risk,
  simulation,
}: {
  risk: AiOperationalRiskLevel | 'UNKNOWN'
  simulation?: AiOperationSimulation | null
}) => {
  const risks = simulation?.risks ?? []
  const governance = simulation?.governanceRequirements ?? []
  if (!risks.length && !governance.length) return null
  return (
    <section className="aiExecutionRiskPanel" aria-label="Execution risk and governance">
      <div className="aiExecutionPanelHeader">
        <strong>Risk and governance</strong>
        <ExecutionRiskBadge risk={risk} />
      </div>
      <ul>
        {risks.slice(0, 4).map((item, index) => (
          <li key={`risk-${index}`}>{item.message}</li>
        ))}
        {governance.slice(0, 4).map((item, index) => (
          <li key={`governance-${index}`}>{item}</li>
        ))}
      </ul>
    </section>
  )
}
